import { useState } from 'react';
import Flag from 'react-world-flags';
import { Navbar, Container, Nav, NavDropdown, Image } from 'react-bootstrap';
import { NavLink, useNavigate } from 'react-router-dom';
import logo from '../../assets/GiantLog-logo.png';
import ChangePasswordModal from '../../pages/ChangePasswordModal';
import AirportInfo from '../AirportInfo';
import { getUiInterface } from "../../locales/translationUtils";
import { useTranslation } from 'react-i18next';

const Header: React.FC = () => {
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  const handleOptionSelect = (eventKey: string | null) => {
    if (eventKey === 'logout') {
      localStorage.clear();
      sessionStorage.clear();
      navigate('/login');
    }
  };

  const handleOpenModal = () => setShowChangePasswordModal(true);
  const handleCloseModal = () => setShowChangePasswordModal(false);

  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div>
      <Navbar bg="light" expand="lg" className="border-bottom shadow-sm">
        <Container fluid>
          <Navbar.Brand as={NavLink} to="/">
            <Image src={logo} alt="Logo" style={{ width: '100px', height: 'auto' }} />
          </Navbar.Brand>

          <Nav className="ms-auto">
            <NavDropdown
              title={<i className="bi bi-gear-wide fs-4"></i>}
              id="user-menu"
              align="end"
              onSelect={handleOptionSelect}>
              <NavDropdown.Item eventKey="logout">
                {getUiInterface('logout')}
              </NavDropdown.Item>

              <NavDropdown.Item onClick={handleOpenModal}>
                {getUiInterface('changePassword')}
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              title={<i className="bi bi-globe fs-4"></i>}
              id="language-menu"
              align="end">
              <NavDropdown.Item disabled>
                {i18n.language.toUpperCase()}
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleLanguageChange('pt')}>
                <Flag code="BRA" height="16"/> Português
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleLanguageChange('en')}>
                <Flag code="USA" height="12"/> English
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>

          <ChangePasswordModal show={showChangePasswordModal} onClose={handleCloseModal} />
        </Container>
      </Navbar>
      <div className='p-3'>
        <AirportInfo />
      </div>
    </div>
  );
};

export default Header;
